export default "__VITE_ASSET__9ac1b67f__"